import { AiBanner, Css } from "@homebound/beam";
import { AiFieldProposalStatus } from "src/generated/graphqlTypes";

export type PlanPackageAiReviewBannerProps = {
  /** Renders nothing when false. */
  hasPending: boolean;
  /** How many proposals need attention before they can be applied. */
  warnings: number;
  /** Called with the decision for every pending proposal on the tab. */
  onReconcileAll: (decision: AiFieldProposalStatus.Accepted | AiFieldProposalStatus.Rejected) => void;
};

/**
 * The Accept All / Ignore All banner shown above a plan package tab with AI proposals awaiting
 * review.
 */
export function PlanPackageAiReviewBanner(props: PlanPackageAiReviewBannerProps) {
  const { hasPending, warnings, onReconcileAll } = props;
  if (!hasPending) return null;
  return (
    // TODO: Move this to the banner slot in the PageHeaderLayout once available.
    // https://linear.app/homebound-team/issue/DS-385/move-plan-package-ai-banner-into-banner-slot
    <div css={Css.mt(-3).$}>
      <AiBanner
        title="Review changes to your plan found in your latest document capture."
        message={`Review the changes highlighted below${warnings > 0 ? ` including ${warnings} warning${warnings === 1 ? "" : "s"}` : ""}.`}
        primaryAction={{ label: "Accept All", onClick: () => onReconcileAll(AiFieldProposalStatus.Accepted) }}
        secondaryAction={{ label: "Ignore All", onClick: () => onReconcileAll(AiFieldProposalStatus.Rejected) }}
      />
    </div>
  );
}
